module.exports = __webpack_public_path__ + "static/img/bg.e231b27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nhfy/bg.jpg
// module id = UExf
// module chunks = 2